import { useAuth } from "@/lib/auth";

export default function SettingsPage() {
    const { user } = useAuth();
    return (
        <div className="p-8 space-y-6" data-testid="settings-page">
            <div>
                <p className="label-tiny mb-2">/ Account</p>
                <h1 className="font-serif text-6xl">Settings</h1>
            </div>
            <div className="border border-[var(--border)] bg-[var(--surface)] p-6 max-w-xl space-y-4">
                <div>
                    <p className="label-tiny mb-1">Coach name</p>
                    <p className="text-lg">{user?.name}</p>
                </div>
                <div>
                    <p className="label-tiny mb-1">Email</p>
                    <p className="font-mono text-sm">{user?.email}</p>
                </div>
                <div>
                    <p className="label-tiny mb-1">Role</p>
                    <p className="tag-pill inline-block">{user?.role}</p>
                </div>
                <div>
                    <p className="label-tiny mb-1">Member since</p>
                    <p className="font-mono text-sm">{new Date(user?.created_at).toLocaleDateString()}</p>
                </div>
            </div>
            <p className="text-sm text-[var(--text-muted)]">
                More settings (password change, billing details, branding) coming next.
            </p>
        </div>
    );
}
